export default "__VITE_ASSET__8e4caec4__"